import React from "react";
import { DadosProvider } from "./hooks/cartao";
import "./styles/globalStyles.css";
import Home from "./pages/Home";
import { ClearBrowserCacheBoundary } from "react-clear-browser-cache";

function App() {
  return (
    <ClearBrowserCacheBoundary auto fallback="Carregando..." duration={60000}>
      <DadosProvider>
        <Home />
      </DadosProvider>
    </ClearBrowserCacheBoundary>
  );
}

export default App;
